// extracted by mini-css-extract-plugin
module.exports = {"stepper":"_1j7I8xSXnoDC05UkMC6gWU","icon":"_2s0VpAY16WtT3_NNOeHAHT"};